import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { navLinks } from "@/data/siteContent";

export const SiteHeader = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header
      className="fixed top-0 z-50 w-full border-b border-blue-200/20 bg-background/90 backdrop-blur-xl"
      data-testid="site-header"
    >
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-10">
        <NavLink
          to="/"
          className="inline-flex items-center"
          data-testid="brand-logo-link"
        >
          <img
            src="/company-logos/purnam-white-clean.png"
            alt="Purnam Talent Management"
            className="h-8 w-auto sm:h-10 lg:h-11"
            data-testid="brand-logo-image"
          />
        </NavLink>

        <nav className="hidden items-center gap-6 md:flex" data-testid="desktop-navbar">
          {navLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              className={({ isActive }) =>
                `font-oswald text-sm uppercase tracking-[0.18em] transition-colors duration-300 ${
                  isActive ? "text-accent" : "text-blue-100/80 hover:text-white"
                }`
              }
              data-testid={`nav-link-${link.label.toLowerCase()}`}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <button
          type="button"
          onClick={() => setIsOpen((prev) => !prev)}
          className="inline-flex rounded-full border border-blue-200/35 p-2 text-white transition-colors duration-300 hover:border-accent hover:text-accent md:hidden"
          aria-label="Toggle navigation"
          data-testid="mobile-menu-toggle"
        >
          {isOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {isOpen && (
        <nav
          className="border-t border-blue-200/20 bg-[#04143d]/95 px-4 py-4 md:hidden"
          data-testid="mobile-navbar"
        >
          <div className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className="font-oswald text-sm uppercase tracking-[0.2em] text-blue-100/85 transition-colors hover:text-accent"
                data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
              >
                {link.label}
              </NavLink>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
};